export default __webpack_public_path__ + "maps-examples-annotation-views-960-2c33d4975708310849b6ba8721724780.webp";